function cleanTaskData(obj) {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => (value === '' ? [key, null] : [key, value])));
}
export { cleanTaskData };
